import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Explainer from "@/pages/Explainer";
import MLTC from "@/pages/MLTC";
import Learning from "@/pages/Learning";

function App() {
    return (
        <div className="App">
            <ErrorBoundary>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<MLTC />} />
                        <Route path="/learning" element={<Learning />} />
                        <Route path="/explainer" element={<Explainer />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </ErrorBoundary>
        </div>
    );
}

class ErrorBoundary extends React.Component {
    state = { hasError: false };
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
                    <div
                        className="max-w-md rounded-sm border border-slate-200 bg-white p-8"
                        data-testid="app-error-boundary"
                    >
                        <h1 className="text-lg font-medium text-slate-900">
                            The explainer could not be loaded
                        </h1>
                        <button
                            onClick={() => window.location.reload()}
                            data-testid="app-error-retry-btn"
                            className="mt-5 rounded-sm bg-blue-950 px-4 py-2 text-sm font-medium text-white hover:bg-blue-900"
                        >
                            Retry
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default App;
